import { defineComponent as _defineComponent } from 'vue'
import axios from "axios";
import { ref } from "vue";

import PaymentMethodWidget from "@/UI/widgets/PaymentMethodWidget.vue";
import BusyOverlay from "@/UI/widgets/BusyOverlay.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPage',
  props: {
  userCards: Array
},
  setup(__props) {

const props = __props;



let paymentMethodWidget = ref();
let isSending = ref(false);
let output = ref<string | null>(null);

function handleCheckoutClick() {
  isSending.value = true;

  paymentMethodWidget.value.requestPaymentMethod()
    .then((payment: any) => {
      axios
        .post('/sandbox/checkout', {
          payment: {
            token: payment?.nonce,
            method: payment?.type,
          }
        })
        .then((response) => {
          output.value = JSON.stringify(response.data);
        })
        .finally(() => {
          isSending.value = false;
        });
    });
}

return { __sfc: true,props, paymentMethodWidget, isSending, output, handleCheckoutClick, PaymentMethodWidget, BusyOverlay }
}

})